<template>
  <div class="financial-statistics">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>财务统计</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <div class="search-fields">
        <el-input
          placeholder="交易流水号"
          prefix-icon="el-icon-document"
          size="small"
          v-model="searchForm.transactionId"
          clearable
          @keyup.enter.native="query"
        ></el-input>
        <el-input
          placeholder="订单编号"
          prefix-icon="el-icon-tickets"
          size="small"
          v-model="searchForm.orderNo"
          clearable
          @keyup.enter.native="query"
        ></el-input>
        <el-input
          placeholder="商品名称"
          prefix-icon="el-icon-goods"
          size="small"
          v-model="searchForm.productName"
          clearable
          @keyup.enter.native="query"
        ></el-input>
        <el-input
          placeholder="买家名称"
          prefix-icon="el-icon-user"
          size="small"
          v-model="searchForm.buyerName"
          clearable
          @keyup.enter.native="query"
        ></el-input>
        <el-input
          placeholder="买家手机号"
          prefix-icon="el-icon-mobile-phone"
          size="small"
          v-model="searchForm.buyerMobile"
          clearable
          @keyup.enter.native="query"
        ></el-input>
        <el-date-picker
          v-model="searchForm.payTimeRange"
          size="small"
          type="datetimerange"
          range-separator="至"
          start-placeholder="支付开始时间"
          end-placeholder="支付结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.refundTimeRange"
          size="small"
          type="datetimerange"
          range-separator="至"
          start-placeholder="退款开始时间"
          end-placeholder="退款结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <el-input
          placeholder="客户来源"
          prefix-icon="el-icon-connection"
          size="small"
          v-model="searchForm.customerSource"
          clearable
          @keyup.enter.native="query"
        ></el-input>
      </div>
      <div class="search-btns">
        <el-button type="primary" size="small" @click="query">搜索</el-button>
        <el-button size="small" @click="reset">重置</el-button>
        <el-button type="success" size="small" @click="exportData" :loading="exportLoading">
          {{ exportLoading ? '导出中...' : '导出' }}
        </el-button>
      </div>
    </div>
    <div class="list">
      <el-table
        :data="list"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        size="small"
        stripe
        border
        v-loading="listLoading"
      >
        <el-table-column prop="transaction_id" label="交易流水号" min-width="180" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="order_no" label="订单编号" min-width="180" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="product_name" label="商品名称" min-width="120" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="unit_price" label="单价(元)" align="center" show-overflow-tooltip>
          <template slot-scope="scope">¥{{ formatPrice(scope.row.unit_price) }}</template>
        </el-table-column>
        <el-table-column prop="order_amount" label="订单金额(元)" align="center" show-overflow-tooltip>
          <template slot-scope="scope">¥{{ formatPrice(scope.row.order_amount) }}</template>
        </el-table-column>
        <el-table-column prop="actual_payment" label="实付金额(元)" align="center" show-overflow-tooltip>
          <template slot-scope="scope">¥{{ formatPrice(scope.row.actual_payment) }}</template>
        </el-table-column>
        <el-table-column prop="buyer_name" label="买家名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="buyer_mobile" label="买家手机号" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="payment_time" label="支付时间" min-width="165" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="fund_status" label="资金状态" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag :type="getFundStatusType(scope.row.fund_status)" size="small">
              {{ scope.row.fund_status || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="refund_time" label="退款时间" min-width="165" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.refund_time || '-' }}</template>
        </el-table-column>
        <el-table-column prop="refund_amount" label="退款金额(元)" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.refund_amount != null && scope.row.refund_amount !== '' ? '¥' + formatPrice(scope.row.refund_amount) : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="refund_type" label="退款方式" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.refund_type || '-' }}</template>
        </el-table-column>
        <el-table-column prop="settlement_time" label="结算时间" min-width="165" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="customer_source" label="客户来源" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FinancialStatistics',
  data() {
    return {
      searchForm: {
        transactionId: '',
        orderNo: '',
        productName: '',
        buyerName: '',
        buyerMobile: '',
        payTimeRange: null,
        refundTimeRange: null,
        customerSource: ''
      },
      list: [],
      pages: 1,
      limit: 10,
      total: 0,
      listLoading: false,
      exportLoading: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      const { transactionId, orderNo, productName, buyerName, buyerMobile, payTimeRange, refundTimeRange, customerSource } = this.searchForm
      let url = `/v1/admin/finance/stats?page=${this.pages}&limit=${this.limit}`
      if (transactionId) url += `&transaction_id=${encodeURIComponent(transactionId)}`
      if (orderNo) url += `&order_no=${encodeURIComponent(orderNo)}`
      if (productName) url += `&product_name=${encodeURIComponent(productName)}`
      if (buyerName) url += `&buyer_name=${encodeURIComponent(buyerName)}`
      if (buyerMobile) url += `&buyer_mobile=${encodeURIComponent(buyerMobile)}`
      if (customerSource) url += `&customer_source=${encodeURIComponent(customerSource)}`
      if (payTimeRange && payTimeRange.length === 2) {
        url += `&payment_time_start=${encodeURIComponent(payTimeRange[0])}&payment_time_end=${encodeURIComponent(payTimeRange[1])}`
      }
      if (refundTimeRange && refundTimeRange.length === 2) {
        url += `&refund_time_start=${encodeURIComponent(refundTimeRange[0])}&refund_time_end=${encodeURIComponent(refundTimeRange[1])}`
      }
      this.$get(url, {})
        .then((res) => {
          this.listLoading = false
          if (res.data && res.data.status === 'success' && res.data.data) {
            const d = res.data.data
            this.list = d.list || []
            this.total = d.total || 0
          } else {
            this.list = []
            this.total = 0
            this.$message.error((res.data && res.data.msg) || '请求失败')
          }
        })
        .catch(() => {
          this.listLoading = false
          this.list = []
          this.total = 0
        })
    },
    formatPrice(val) {
      if (val === undefined || val === null) return '0.00'
      const num = typeof val === 'number' ? val : parseFloat(val)
      if (isNaN(num)) return '0.00'
      return (num >= 100 ? num / 100 : num).toFixed(2)
    },
    getPayStatusType(status) {
      const map = { SUCCESS: 'success', REFUND: 'danger', NOTPAY: 'warning', pending: 'warning', paid: 'success', completed: 'info', refunded: 'danger' }
      return map[status] || 'info'
    },
    getPayStatusText(status) {
      const map = { SUCCESS: '支付成功', REFUND: '已退款', NOTPAY: '待支付', pending: '待支付', paid: '已支付', completed: '已完成', refunded: '已退款' }
      return map[status] || (status ? String(status) : '-')
    },
    getFundStatusType(status) {
      const map = {
        '已支付': 'success',
        '已退款': 'danger',
        '退款中': 'warning',
        pending: 'warning',
        settled: 'success',
        refunded: 'danger'
      }
      return map[status] || 'info'
    },
    getFundStatusText(status) {
      const map = { pending: '待结算', settled: '已结算', refunded: '已退款' }
      return map[status] || (status ? String(status) : '-')
    },
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 1 ? '' : 'success-row'
    },
    query() {
      this.pages = 1
      this.getList()
    },
    reset() {
      this.searchForm = {
        transactionId: '',
        orderNo: '',
        productName: '',
        buyerName: '',
        buyerMobile: '',
        payTimeRange: null,
        refundTimeRange: null,
        customerSource: ''
      }
      this.pages = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.limit = val
      this.pages = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pages = val
      this.getList()
    },
    exportData() {
      this.exportLoading = true
      const { transactionId, orderNo, productName, buyerName, buyerMobile, payTimeRange, refundTimeRange, customerSource } = this.searchForm
      let url = `/v1/admin/finance/export?`
      if (transactionId) url += `&transaction_id=${encodeURIComponent(transactionId)}`
      if (orderNo) url += `&order_no=${encodeURIComponent(orderNo)}`
      if (productName) url += `&product_name=${encodeURIComponent(productName)}`
      if (buyerName) url += `&buyer_name=${encodeURIComponent(buyerName)}`
      if (buyerMobile) url += `&buyer_mobile=${encodeURIComponent(buyerMobile)}`
      if (customerSource) url += `&customer_source=${encodeURIComponent(customerSource)}`
      if (payTimeRange && payTimeRange.length === 2) {
        url += `&payment_time_start=${encodeURIComponent(payTimeRange[0])}&payment_time_end=${encodeURIComponent(payTimeRange[1])}`
      }
      if (refundTimeRange && refundTimeRange.length === 2) {
        url += `&refund_time_start=${encodeURIComponent(refundTimeRange[0])}&refund_time_end=${encodeURIComponent(refundTimeRange[1])}`
      }
      url = url.replace(/\?&/, '?').replace(/\?$/, '') || '/v1/admin/finance/export'
      this.$getFile(url, {})
        .then((res) => {
          if (res && res.status === 200 && res.data) {
            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const date = new Date()
            const timeStr = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}${String(date.getHours()).padStart(2, '0')}${String(date.getMinutes()).padStart(2, '0')}${String(date.getSeconds()).padStart(2, '0')}`
            const a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `财务统计_${timeStr}.xlsx`
            a.click()
            URL.revokeObjectURL(a.href)
            this.$message.success('导出成功')
          } else {
            this.$message.error('导出失败')
          }
        })
        .catch(() => {
          this.$message.error('导出失败')
        })
        .finally(() => {
          this.exportLoading = false
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.financial-statistics
  .search
    margin 20px 0
    .search-fields
      display flex
      flex-wrap wrap
      align-items center
      gap 12px
    .search-btns
      display flex
      align-items center
      gap 12px
      margin-top 12px
    .el-input
      width 160px
    .el-date-editor
      width 360px

  .list
    margin-top 20px
    min-height 400px
    border 1px solid #EBEEF5

  .block
    margin-top 10px

  .el-table .success-row
    background #f0f9eb
</style>



// WEBPACK FOOTER //
// src/pages/FinanceManage/FinancialStatistics.vue